module.exports = __webpack_public_path__ + "static/img/cangku1.e28a163e.png";